import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useRef } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { AnimatedGrid } from '../AnimatedSection';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';

const Built: React.FC = () => {
    const { t } = useLang('Built');
    const swiperRef = useRef<any>(null);

    const list = [
        {
            title: t('list1_title'),
            desc: t.rich('list1_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757756429435-cqlafb-compressed-%E8%8A%AF%E7%89%87.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1757756429435-cqlafb-compressed-%E8%8A%AF%E7%89%87.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757758983900-qjhq90-compressed-%E8%8A%AF%E7%89%87-1%E5%BA%A6%E7%94%B5.jpg',
        },
        {
            title: t('list2_title'),
            desc: t.rich('list2_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758710600121-j0jtp6-compressed-image.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758710600121-j0jtp6-compressed-image.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758710662948-m5jxpq-compressed-2.jpg',
        },
        {
            title: t('list3_title'),
            desc: t.rich('list3_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758710629108-18wg83-compressed-%E9%A3%8E%E6%9A%B4.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758710629108-18wg83-compressed-%E9%A3%8E%E6%9A%B4.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758710681517-2pwkwv-compressed-3.jpg',
        },
        {
            title: t.rich('list4_title', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t.rich('list4_desc', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758879515108-yh3efr-compressed-image.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758879541815-bhhlb1-compressed-4.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758879541815-bhhlb1-compressed-4.jpg',
        },
    ];

    const handlePrev = (name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('title'),
            button_name: name,
        });
    };

    const handleNext = (name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('title'),
            button_name: name,
        });
    };

    return (
        <div className={`${styles.Built} GtmModuleData-section`} data-section-id="d3c-Built" id="Built">
            <EcoSpace />
            <AnimatedGrid variant="fadeInUp" options={{ delay: 200, stagger: 0.2 }} className="d3m-title-common">
                <EcoSectionCommon className="d3m-title-common d3m-layout" title={t('title')} desc={t('desc')} />
                <div className="swiper-built d3m-layout">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={'auto'}
                        spaceBetween={24}
                        modules={[Navigation]}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        initialSlide={0}
                    >
                        {list.map((item, index) => (
                            <SwiperSlide key={index}>
                                <div className="list-item">
                                    <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy={true} />

                                    <div className="text-wrapper">
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                        <div className="swiper-button-prev" onClick={() => handlePrev('Left switch')} />
                        <div className="swiper-button-next" onClick={() => handleNext('Right switch')} />
                    </Swiper>
                </div>
            </AnimatedGrid>

            <EcoSpace />
        </div>
    );
};

export default Built;
